import $ from "jquery";

(function () {
    'use strict';

    let searchDebounceTimer;
    const CONTAINER_SELECTOR = ".rhfoto-post-category";

    const categoryDiv = document.querySelector(".rhfoto-post-category");
    if (!categoryDiv) {
        return;
    }

    const categoryButtons = categoryDiv.querySelectorAll("a");
    $(categoryButtons).on("click", function (event)  {
        event.preventDefault();

        const slug = $(this).data("slug");
        updateActiveState(this);
        displayLoading();
        $(categoryDiv).find('input.post-search').val('');

        $.ajax({
            type: "post",
            dataType: "json",
            url: "/wp-admin/admin-ajax.php",
            data: {
                action: "list_posts",
                category_slug: slug
            },
            success: function (response) {
                displayPosts(response.posts);
            },
            error: function () {
                displayFailed();
            }
        })
    });

    $(categoryDiv).find('input.post-search').on('input', function (event) {
        const value = this.value.trim();
        const activeCategorySlug = getActiveCategorySlug();

        displayLoading();

        searchDebounce(() => {
            $.ajax({
                type: "post",
                dataType: "json",
                url: "/wp-admin/admin-ajax.php",
                data: {
                    action: "search_posts",
                    category_slug: activeCategorySlug,
                    search: value
                },
                success: function (response) {
                    displayPosts(response.posts);
                },
                error: function () {
                    displayFailed();
                }
            })
        }, 500);
    });

    init();

    function searchDebounce(callback, timer) {
        clearTimeout(searchDebounceTimer);
        searchDebounceTimer = setTimeout(callback, timer);
    }

    function init() {
        const $activeCategory = $(categoryDiv).find('a.active');
        if ($activeCategory.length > 0) {
            $activeCategory[0].click();
        }
    }

    function updateActiveState(activeButton) {
        $(categoryButtons).removeClass('active');
        $(activeButton).addClass('active');
    }

    function getActiveCategorySlug() {
        const activeCategory = $(CONTAINER_SELECTOR).find('a.active');
        if (activeCategory.length === 0) {
            return $($(CONTAINER_SELECTOR).find('a')[0]).data('slug');
        }

        return $(activeCategory[0]).data('slug');
    }

    function displayLoading() {
        const $postsContainer = $('.rhfoto-photo-category');
        if ($postsContainer.length === 0) {
            return;
        }

        $postsContainer.html('Loading...');
    }

    function displayFailed() {
        const $postsContainer = $('.rhfoto-photo-category');
        if ($postsContainer.length === 0) {
            return;
        }

        $postsContainer.html('Failed to load photos');
    }

    function displayPosts(posts) {
        const $postsContainer = $('.rhfoto-photo-category');
        if ($postsContainer.length === 0) {
            return;
        }

        $postsContainer.html(''); // clean everything

        if (posts.length === 0) {
            $postsContainer.html('No photos found');
            return;
        }

        const html = [];
        posts.forEach(post => {
            html.push(`
                <a href=${post.link}>
                    <div class="background-image" style="background-image: url('${post.image}')"></div>
                    <span>${post.title}</span>
                </a>
            `);
        });
        $postsContainer.html(html.join(''));
    }
})();